import { useState, useEffect } from 'react'
import { ItemAttribute } from '../../../../../types/interfaces'

export const useDynamicSelect = (el: ItemAttribute) => {
  const [arrayValue, setArrayValue] = useState<string[]>([])
  
  useEffect(() => {
    if (el.value == null) {
      setArrayValue([])
      return
    }
    
    if (Array.isArray(el.value)) {
      setArrayValue([...el.value])
      return
    }
    
    if (typeof el.value === 'string') {
      const trimmed = el.value.trim()
      
      if (!trimmed) {
        setArrayValue([])
        return
      }
      
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed)
          if (Array.isArray(parsed)) {
            setArrayValue(parsed.map(String).filter(Boolean))
            return
          }
        } catch {
          // Ошибка парсинга - продолжаем
        }
      }
      
      if (trimmed.includes(',')) {
        setArrayValue(trimmed.split(',').map(s => s.trim()).filter(Boolean))
        return
      }
      
      setArrayValue([trimmed])
      return
    }
    
    setArrayValue([String(el.value)])
  }, [el.value])

  return { arrayValue, setArrayValue }
}